import Glider from 'glider-js';
import debounce from 'lodash.debounce';

import { CSS_PREFIX } from './constants';

const BASE_CAROUSEL_CLASS = `${CSS_PREFIX}related-players-carousel`;
const BASE_CAROUSEL_ITEM_CLASS = `${BASE_CAROUSEL_CLASS}-item`;

const CAROUSEL_TAB_ITEM_ACTIVE = `${BASE_CAROUSEL_CLASS}__tabs-item--active`;

let tabItems: Element[] = [];

const buttonClickHandler = (e: Event, glider: Glider<HTMLElement>): void => {
  e.preventDefault();
  // @ts-ignore
  const category = e.target.dataset.category;
  scrollToFirstInCat(category, glider);
};

const scrollToFirstInCat = (cat: string, glider: Glider<HTMLElement>): void => {
  const slideIndex = document.querySelector<HTMLAnchorElement>(`.${BASE_CAROUSEL_ITEM_CLASS}[data-category="${cat}"]`)
    ?.dataset.gslide;

  if (slideIndex) {
    glider.scrollItem(parseInt(slideIndex, 10), false);
  }
};

const debouncedSliderHandler = debounce((tabsGlider: Glider<HTMLElement> | null) => {
  const slide: HTMLElement | null = document.querySelector(`.${BASE_CAROUSEL_ITEM_CLASS}.active`);
  if (slide) {
    const category = slide.dataset.category;
    const tabToActivate = document.querySelector<HTMLButtonElement>(
      `.${BASE_CAROUSEL_CLASS}__tabs-item[data-category="${category}"]`
    );
    const activeTab = document.querySelector<HTMLButtonElement>(`.${BASE_CAROUSEL_CLASS}__tabs-item--active`);

    activeTab?.classList.remove(CAROUSEL_TAB_ITEM_ACTIVE);

    if (tabToActivate) {
      tabToActivate.classList.add(CAROUSEL_TAB_ITEM_ACTIVE);
      const slideIndex = tabToActivate.dataset.gslide;
      if (slideIndex) {
        tabsGlider?.scrollItem(parseInt(slideIndex, 10), false);
      }
    }

    // lets add a little bit of animation magic here
    // we are going to get the index of both the active tab
    // and the tab to activate
    const tabToActivateIndex = tabItems.indexOf(tabToActivate!);
    const activeTabIndex = tabItems.indexOf(activeTab!);

    // if the indeces are different, we are managing different tabs, so we need to
    // remove some classes that could be there from previous iterations
    if (tabToActivateIndex !== activeTabIndex) {
      tabToActivate?.classList.remove(`${CSS_PREFIX}closing--l`, `${CSS_PREFIX}closing--r`);
      activeTab?.classList.remove(`${CSS_PREFIX}opening--l`, `${CSS_PREFIX}opening--r`);
    }

    // now we check if the active index is higher / lower than the tab to active
    // based on which one we can assume that we animate from left-to-right o vice versa
    if (tabToActivateIndex > activeTabIndex) {
      tabToActivate?.classList.add(`${CSS_PREFIX}opening--l`);
      activeTab?.classList.add(`${CSS_PREFIX}closing--r`);
    } else if (tabToActivateIndex < activeTabIndex) {
      tabToActivate?.classList.add(`${CSS_PREFIX}opening--r`);
      activeTab?.classList.add(`${CSS_PREFIX}closing--l`);
    }
  }
}, 150);

export default () => {
  const carouselWrapper = document.querySelector<HTMLDivElement>(`.${BASE_CAROUSEL_CLASS}__carousel`);
  const tabsCarouselWrapper = document.querySelector<HTMLDivElement>(`.${BASE_CAROUSEL_CLASS}__tabs`);

  // for the animations to work we need to get there index every time a tab changes
  // to do so we will use indexOf from an array of nodes. Querying the nodes
  // every time is a big no no. So we are gonna to do it once and cache it
  // in a global variable
  const tabItemsQuery = tabsCarouselWrapper?.querySelectorAll(`.${BASE_CAROUSEL_CLASS}__tabs-track button`);
  if (tabItemsQuery) {
    tabItems = Array.from(tabItemsQuery);
  }

  if (carouselWrapper) {
    const glider = new Glider(carouselWrapper, {
      draggable: true,
      skipTrack: true,
      scrollLock: true,
      exactWidth: true,
      itemWidth: 235,
      slidesToShow: 'auto',
      slidesToScroll: 1,
      duration: 0.5,
      rewind: true,
      arrows: {
        prev: `.${BASE_CAROUSEL_CLASS}__arrow-left`,
        next: `.${BASE_CAROUSEL_CLASS}__arrow-right`,
      },
      responsive: [
        {
          breakpoint: 740,
          settings: {
            itemWidth: 255,
            slidesToShow: 'auto',
            slidesToScroll: 1,
          },
        },
      ],
    });

    let tabsGlider: Glider<HTMLElement> | null = null;
    if (tabsCarouselWrapper) {
      tabsGlider = new Glider(tabsCarouselWrapper, {
        slidesToShow: 'auto',
        slidesToScroll: 1,
        draggable: true,
        skipTrack: true,
        scrollLock: false,
        rewind: false,
        exactWidth: true,
        itemWidth: 140,
        arrows: { prev: null, next: null },
      });
    }

    carouselWrapper.addEventListener('glider-slide-visible', () => debouncedSliderHandler(tabsGlider));

    document
      .querySelectorAll(`button.${BASE_CAROUSEL_CLASS}__tabs-item`)
      ?.forEach((button) => button.addEventListener('click', (e) => buttonClickHandler(e, glider)));

    const currentCat = document.querySelector<HTMLDivElement>(`aside.${BASE_CAROUSEL_CLASS}`)?.dataset.currentCat;
    if (currentCat) {
      scrollToFirstInCat(currentCat, glider);
    }
  }
};
